import { mergeQueryKeys } from '@lukemorales/query-key-factory';
import { classQueries } from 'src/core/services/classes/queries';
import { uploadQueries } from 'src/core/services/upload/queries';
import { contentQueries } from 'src/modules/contents/queries';
import { mentorshipsQueries } from 'src/modules/mentorship/queries';
import { modulesQueries } from 'src/modules/modules/queries';
import { productQueries } from 'src/modules/product/queries';
export const queries = mergeQueryKeys(contentQueries, modulesQueries, mentorshipsQueries, productQueries, uploadQueries, classQueries);
